import { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "分类", path: "/category" },
  { label: "专题", path: "/topic" },
  { label: "搜索", path: "/search" },
  { label: "关于", path: "/about" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const submitSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
    setMenuOpen(false);
  };

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3.5 py-2 rounded-md text-sm transition-colors duration-200 ${
      isActive
        ? "text-primary-700 bg-primary-50 font-medium"
        : "text-foreground-600 hover:text-primary-700 hover:bg-background-100"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center gap-4 md:gap-8">
        <Link to="/" className="flex items-center gap-3 shrink-0 cursor-pointer" onClick={() => setMenuOpen(false)}>
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-600 text-background-50 flex items-center justify-center font-heading text-lg md:text-xl">
            一
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base md:text-lg text-foreground-950 tracking-wide">日本一级片</span>
            <span className="hidden sm:block text-[10px] tracking-[0.28em] text-foreground-500 mt-1 font-label">
              JP CINEMA ARCHIVE
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={navClass} end={item.path === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden lg:flex items-center gap-2 w-[300px] shrink-0">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索影片标题"
              aria-label="搜索影片标题"
              className="w-full h-9 pl-9 pr-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition"
            />
          </div>
          <button
            type="submit"
            className="h-9 px-3.5 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap hover:bg-primary-700 transition-colors cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex md:hidden items-center gap-2 ml-auto">
          <Link
            to="/search"
            aria-label="搜索影片"
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700"
          >
            <i className="ri-search-line text-base w-5 h-5 flex items-center justify-center"></i>
          </Link>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-lg w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4">
            <form onSubmit={submitSearch} className="flex items-center gap-2 mb-3">
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影片标题"
                aria-label="搜索影片标题"
                className="flex-1 h-10 px-3 rounded-md border border-background-300 bg-background-50 text-sm focus:outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                className="h-10 px-4 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap"
              >
                搜索
              </button>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMenuOpen(false)}
                  className={`flex items-center justify-between px-3 py-3 rounded-md text-sm ${
                    location.pathname === item.path
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}